import React from 'react';
import PropTypes from 'prop-types';
import FullPageLayout from '../layouts/fullPageLayout';
import withBlockedBackNavigation from '../utils/withBlockedBackNavigation';
import AlyxInterstitialView from './components/AlyxInterstitialView';

const InterstitialView = props => (
    <FullPageLayout>
        <AlyxInterstitialView
            recentlyCompletedMeasure={props.recentlyCompletedMeasure}
            onAnimationEnd={props.goToNextPage}
        />
    </FullPageLayout>
);

InterstitialView.propTypes = {
    goToNextPage: PropTypes.func.isRequired,
    recentlyCompletedMeasure: PropTypes.string.isRequired,
};

export default withBlockedBackNavigation(InterstitialView);
